import { IConsentForm } from "@/api/dtos";
import { useCrfFormSubmit } from "@ngt/opms";

const useEConsentFormSubmit =  <TData extends IConsentForm = IConsentForm>() => useCrfFormSubmit<TData>();

export default useEConsentFormSubmit;